// Sprockets-bundled photoswipe.js mirrors these builders inline — it can't import this Vite module.

const toInt = (value) => {
  const parsed = parseInt(value, 10)
  return Number.isNaN(parsed) ? null : parsed
}

export const pdpCommonProps = (dataset = {}) => ({
  listing_id: toInt(dataset.pdpListingId),
  artist_id: toInt(dataset.pdpArtistId),
  total_images: toInt(dataset.pdpTotalImages),
  is_reprint: dataset.pdpReprint === "true",
})
